export const oauth2_100103="用户名或者密码错误.";
export const oauth2_100105="登录状态已失效，请重新登录以继续访问.";
export const oauth2_100106="登录状态已失效，请重新登录以继续访问.";
export const oauth2_100107="登录状态已失效，请重新登录以继续访问.";
export const oauth2_100108="登录状态已失效，请重新登录以继续访问.";
export const oauth2_100109="登录状态已失效，请重新登录以继续访问.";
export const oauth2_100110="服务器连接失败,请联系管理员.";
export const oauth2_100111="OA服务器连接失败,请稍后再试.";
